import React from 'react';
export function Footer() {
  return <footer className="py-8 px-6 border-t border-white/5 bg-brand-dark text-center" data-id="element-138">
      <div className="max-w-4xl mx-auto flex flex-col items-center gap-4" data-id="element-139">
        <p className="font-serif text-xl font-bold italic text-brand-cream/50" data-id="element-140">
          Nunca Más Te Dejan en Visto
        </p>
        <p className="text-brand-lightGray/50 text-sm" data-id="element-141">
          © {new Date().getFullYear()} Todos los derechos reservados. Este
          sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
        <div className="flex gap-6 text-sm text-brand-lightGray/50 mt-4" data-id="element-142">
          <a href="#" className="hover:text-brand-rose transition-colors" data-id="element-143">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-brand-rose transition-colors" data-id="element-144">
            Política de Privacidad
          </a>
        </div>
      </div>
    </footer>;
}